import { AbstractControl } from '@angular/forms';

export class ControlUtil {
  public static setError(control: AbstractControl, possibleErrors: string[], errorName: string, value: any) {
    const errors = {};
    possibleErrors.forEach((possibleError: string) => {
      if(possibleError !== errorName) {
        const err = control.getError(possibleError);
        if (err) {
          errors[possibleError] = err;
        }
      } else {
        if (value) {
          errors[errorName] = value;
        }
      }
    });
    if (Object.keys(errors).length > 0) {
      control.setErrors(errors);
    } else {
      control.setErrors(null);
    }
  }
}
